import styles from "./IsaacNavigation.module.scss";
import React from "react";
import {useLocation} from "react-router-dom";
import {Nav, Stack, type INavLinkGroup} from "@fluentui/react";

import {useAuth} from "../../services/auth/hooks/useAuth";
import IsaacBreadCrumb from "../isaacBreadCrumb/IsaacBreadCrumb";

const IsaacNavigation: React.FunctionComponent = () => {
  const location = useLocation();
  const {signOut, user} = useAuth();

  const navLinkGroups: INavLinkGroup[] = [
    {
      links: [
        {
          key: "/user",
          name: `${user?.userName} - v${process.env.REACT_APP_VERSION}`,
          url: "",
        },
        {
          key: "/logout",
          name: "logout",
          url: "",
          iconProps: {iconName: "OutOfOffice", className: `${styles.iconItem}`},
          onClick: () => {
            void (async () => {
              await signOut();
            })();
          },
        },
      ],
    },
  ];

  return (
    <Stack
      enableScopedSelectors
      horizontal
      styles={{
        root: styles.breadCrumbRoot,
      }}>
      <Stack.Item grow={3}>
        <IsaacBreadCrumb iconName="Separator" />
      </Stack.Item>
      <Stack.Item grow>
        <Nav
          selectedKey={location.pathname}
          initialSelectedKey="dashboard"
          ariaLabel="TUCRail Navigation"
          styles={styles}
          className={`${styles.navContainer} ${styles.noPrint}`}
          groups={navLinkGroups}
        />
      </Stack.Item>
    </Stack>
  );
};

export default IsaacNavigation;
